<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'設問セット' | translate}}</h1>

  <!-- <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'quest-set.DELETE' | translate}}</span>
    </button>
  </div> -->
  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="64" style="text-align:center"> No. </th>
      <td mat-cell *matCellDef="let quest_set; let i = index" style="text-align:right"> {{ (i + 1) + (paginator.pageSize
        * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80" style="text-align:center"> {{'編集' |
        translate}} </th>
      <td mat-cell *matCellDef="let quest_set" style="text-align:center">
        <button mat-button color="primary" (click)="openEditDialog(quest_set)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let quest_set">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(quest_set) : null" [checked]="selection.isSelected(quest_set)"
          [aria-label]="checkboxLabel(quest_set)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="200"> {{'ID' | translate}} </th>
      <td mat-cell *matCellDef="let quest_set" [style.width.px]="200"> {{ quest_set.id }} </td>
    </ng-container>

    <ng-container matColumnDef="use_question">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80" style="text-align:center"> {{'表示中' | translate}} </th>
      <td mat-cell *matCellDef="let quest_set" [style.width.px]="80" style="text-align:center">
        <div *ngIf="quest_set.use_question"><mat-icon>done</mat-icon></div>
      </td>
    </ng-container>

    <ng-container matColumnDef="question_title">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'表示タイトル' | translate}} </th>
      <td mat-cell *matCellDef="let quest_set"> {{ quest_set.question_titles |
        multiStringMessage:projectLanguages:projectBaseLang }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'管理名称' | translate}} </th>
      <td mat-cell *matCellDef="let quest_set"> {{ quest_set.name }} </td>
    </ng-container>

    <ng-container matColumnDef="questions">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80" style="text-align:center">
        {{'設問数' | translate}} </th>
      <td mat-cell *matCellDef="let quest_set" [style.width.px]="80" style="text-align:center"> {{
        quest_set.questions.length }} {{'件' | translate}}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="174" style="text-align:left"> {{'作成日時' |
        translate}} </th>
      <td mat-cell *matCellDef="let quest_set" [style.width.px]="150" style="text-align:left"> {{
        quest_set.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>